import { CardBadge } from "../../shared/card-badge";
import { SelectableCard } from "../../shared/selectable-card";

export type BudgetPacingOption = {
  id: string;
  title: string;
  description: string;
  available: boolean;
  status?: string;
};

type BudgetPacingCardProps = {
  option: BudgetPacingOption;
  selected: boolean;
  onSelect: () => void;
};

export function BudgetPacingCard({
  option,
  selected,
  onSelect,
}: BudgetPacingCardProps) {
  return (
    <SelectableCard
      interactive={option.available}
      selected={selected}
      dimmed={!option.available}
      onSelect={onSelect}
    >
      <div className="tw:min-w-0">
        <div className="tw:flex tw:items-center tw:justify-between tw:gap-3">
          <h3 className="tw:min-w-0 tw:text-sm tw:font-semibold tw:text-foreground">
            {option.title}
          </h3>
          {selected ? (
            <CardBadge className="tw:bg-sky-500 tw:text-white">
              Selected
            </CardBadge>
          ) : option.status ? (
            <CardBadge variant="outline">{option.status}</CardBadge>
          ) : null}
        </div>
        <p className="tw:mt-2 tw:text-sm tw:leading-relaxed tw:text-muted-foreground">
          {option.description}
        </p>
      </div>
    </SelectableCard>
  );
}
